import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerFive from "../components/DashBoardLayerFive";


const HomePageFive = () => {
  return (
    <>
     

        <Breadcrumb title="Dashboard"  />

        {/* DashBoardLayerFive */}
        <DashBoardLayerFive />



    </>
  );
};

export default HomePageFive;
